import React from "react"

import { scrollToTopOfCurrentStep } from 'services/break'

export const ScrollToStepButton = ({label= "Click", stepId=null, className="btn", onClickCallback=()=> {}}) => {

    const handleClick = () => {
        scrollToTopOfCurrentStep(stepId)
        onClickCallback()
    }

    return (
        <button className={className}
            onClick={handleClick}
        >
            { label }
        </button>
    )
}

